import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusinessCalendarRoutingModule } from './business-calendar-routing.module';
import { CalendarComponent } from 'src/app/shared/calendar/calendar.component';
import { BusinessCalendarComponent } from 'src/app/pages/business-calendar/business-calendar.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { WeekdayPipe } from 'src/app/pipes/weekday.pipe';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { PreloadSpinnerModule } from 'src/app/shared/preload-spinner/preload-spinner.module';
import { DropdownModule } from 'src/app/shared/dropdown/dropdown.module';


@NgModule({
  declarations: [
    CalendarComponent,
    BusinessCalendarComponent,
    WeekdayPipe,
  ],
  imports: [
    CommonModule,
    BusinessCalendarRoutingModule,
    TranslateModule,
    AngularSvgIconModule,
    PreloadSpinnerModule,
    DropdownModule,
  ],
  exports: [
    CalendarComponent,
  ],
  providers: [
    TranslatePipe,
  ],
})
export class BusinessCalendarModule { }
